import { UseQueryOptions, useQuery } from "@tanstack/react-query";

import { StoreType } from "@/interfaces/domain/StoreType";
import { getStoreTypeById, getStoreTypesRequest } from "@/services/api/storeType";
import { logger } from "@/services/logger";

export const STORE_TYPE_QUERY_KEY = (id = "") => `/store-types/${id}`;

export const useStoreTypes = (options?: UseQueryOptions<StoreType[]>) =>
  useQuery<StoreType[]>({
    queryKey: [STORE_TYPE_QUERY_KEY()],
    queryFn: () => getStoreTypesRequest(),
    ...options,
    onError: (error) => {
      logger.error(error);
      options?.onError(error);
    },
  });

export const useStoreTypeById = (typeId: string, options?: UseQueryOptions<StoreType>) =>
  useQuery<StoreType>({
    queryKey: [STORE_TYPE_QUERY_KEY(typeId)],
    queryFn: () => getStoreTypeById(typeId),
    ...options,
    onError: (error) => {
      logger.error(error);
      options?.onError(error);
    },
  });
